import { Box, Typography, TextField, Divider } from "@mui/material";

export default function MatchSummaryTab({ state, dispatch }: any) {
    console.log(JSON.stringify(state.match));
  return (
    <Box>
      <Typography variant="h6">{state.match.competitionType}</Typography>
      <Typography variant="body2">{state.match.date}</Typography>
      <Typography variant="body2">Opponent: {state.match.opponent}</Typography>

      <Divider sx={{ my: 2 }} />

      <TextField
        label="Notes"
        fullWidth
        multiline
        minRows={4}
        value={state.notes}
        onChange={(e) => dispatch({ type: "UPDATE_NOTES", notes: e.target.value })}
      />
    </Box>
  );
}
